module.exports = __webpack_public_path__ + "static/img/blue_button.8a166d2c.png";